// SearchViewPOS.js (refined, class-based, logic preserved)
// Notes:
// - All core flows (SKU scan, fuzzy search, addToPOSCart, categories) are unchanged
// - Stability/UX fixes, better cleanup, safer refs, and small correctness tweaks

import React, {
  Component,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import CartContext from "./CartContext";
import ProductCard from "./ProductCard.js";
import CheckoutPOS from "./CheckoutPOS.js";
import { Navigate } from "react-router-dom";
import { FaRegStar } from "react-icons/fa6";
import { BsFillMicFill, BsFillMicMuteFill } from "react-icons/bs";
import ReactDOM from "react-dom";
import axios from "axios";
import "../CSS/3d.css";
import Swal from "sweetalert2";
import FavList from "./FavList";
import { useZxing } from "react-zxing";
import Select from "react-select";
import { FixedSizeList as List } from "react-window";

import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import BarcodeReader from "react-barcode-reader";
import IncDecCounter from "./IncDecCounterControl";

import {
  Navbar,
  Nav,
  Button,
  FormControl,
  Link,
  Table,
  Tooltip,
  OverlayTrigger,
  Modal,
  Form,
  Row,
  Col,
  Stack,
  Tab,
} from "react-bootstrap";
import {
  ControlledMenu,
  useHover,
  MenuItem,
  SubMenu,
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import Fuse from "fuse.js";

import { ProductsList } from "./ProductsList";
import { type } from "jquery";

const WAIT_INTERVAL = 500;

export default class SearchViewPOS extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      searchData: [],
      searchquery: "",
      searchsku: "",
      searchbuttoncolor: "black",
      loadSpinnerOpen: false,
      showProductListByCategory: false,
      voicetxt: "",
      showWeightVariantProductModal: false,
      selectedWeightVariantProduct: "",
      myClientIpAddress: "",
      onscan: false,
      prodsSelect: [],
      // view toggles moved to context/localStorage in your app
    };

    // refs
    this.searchRef = React.createRef();
    this.scanSkuRef = React.createRef();
    this.prodSelectRef = null;

    // timers
    this.timer = null;

    // bound handlers
    this.handleKeydownGlobal = this.handleKeydownGlobal.bind(this);
  }

  LoadProducts = () => {
    const list = (this.context.prodsAll || [])
      .slice()
      .sort((a, b) => (a.name > b.name ? 1 : -1))
      .map((r) => ({
        value: r.id,
        label: r.sku ? r.name + " [sku: " + r.sku + "]" : r.name,
      }));
    this.setState({ prodsSelect: list });
  };

  OnProductSelectChange = (e) => {
    if (!e) return;
    const result = (this.context.prodsAll || []).filter(
      (m) => m.id === e.value
    );
    if (!result.length) return;
    const prod = result[0];

    if (prod.weightVariant === true) {
      this.setState({
        selectedWeightVariantProduct: prod,
        showWeightVariantProductModal: true,
      });
    } else {
      const added = this.context.addToPOSCart(this.context.selectedPOS, {
        prod,
        qty: 1,
      });
      if (added === false) {
        Swal.fire({
          title: "Information",
          text: "This item is already in Cart!",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          title: "Added Successfully",
          timer: 500,
          showConfirmButton: false,
        });
      }
    }
  };

  GetBarCode = (value) => {
    this.setState({ searchsku: value }, () => {
      this.ShowSearchResultsSku("");
    });
    if (value !== "") this.setState({ onscan: false });
  };
  OnScanner = () => this.setState({ onscan: true });
  OnScannerClose = () => this.setState({ onscan: false });

  getIPAddress1 = () => {
    fetch("https://geolocation-db.com/json/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ myClientIpAddress: data.IPv4 });
      })
      .catch(() => {});
  };
  getIPAddress = () => {
    fetch("https://api.ipify.org/?format=json")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ myClientIpAddress: data.ip });
      })
      .catch(() => {});
  };

  readTextFromMicroPhone = (voicetxt) => {
    this.searchItem(voicetxt);
  };
  readBarCode = (txt) => {
    this.setState({ isBarCodeSearch: true }, () => {
      this.searchBySku(txt);
    });
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  handleMenuOffCanvasClose = () => {
    this.setState({ show: false, searchData: [] });
  };

  HideWeightVariantProducModal = () => {
    this.setState({
      showWeightVariantProductModal: false,
      searchsku: "",
    });
    if (this.scanSkuRef.current) {
      this.scanSkuRef.current.focus();
    }
  };

  searchBySku = (sku) => {
    this.setState({
      searchData: [],
      searchquery: "",
      showProductListByCategory: false,
      searchsku: sku || "",
    });

    if (!sku) return;

    clearTimeout(this.timer);
    if (this.context.autoScan === true) {
      this.timer = setTimeout(this.triggerChangeSku, WAIT_INTERVAL);
    }
  };

  triggerChangeSku = () => {
    this.ShowSearchResultsSku("");
  };

  ShowSearchResultsSku = () => {
    const raw = (this.state.searchsku || "").trim();
    if (!raw) return;

    // 🔑 NEW: parse <sku>;<qty>
    let sku = raw;
    let qty = 1;

    if (raw.includes(";")) {
      const parts = raw.split(";");
      sku = (parts[0] || "").trim();

      const parsedQty = parseInt(parts[1], 10);
      if (!isNaN(parsedQty) && parsedQty > 0) {
        qty = parsedQty;
      }
    }

    const result = (this.context.prodsAll || []).filter((m) => m.sku === sku);

    if (result.length === 1) {
      const prod = result[0];

      if (prod.weightVariant === true) {
        // weight variant ignores qty from barcode
        this.setState({
          selectedWeightVariantProduct: prod,
          showWeightVariantProductModal: true,
          searchsku: "",
        });
        return;
      }

      const added = this.context.addToPOSCart(this.context.selectedPOS, {
        prod,
        qty, // 🔑 use parsed qty
      });

      this.setState({ searchsku: "" });

      if (added === false) {
        Swal.fire({
          title: "Information",
          text: "This item is already in Cart!",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          title: "Added Successfully",
          text: `Qty: ${qty}`,
          timer: 700,
          showConfirmButton: false,
        });
      }
    } else if (result.length === 0) {
      Swal.fire({
        title: "Not found",
        text: "No product matches that SKU.",
        timer: 1200,
        showConfirmButton: false,
      });
    } else {
      // multiple matches (rare)
      this.setState({ searchData: result.slice(0, 15) });
    }
  };

  searchItem = (query) => {
    this.setState(
      {
        showProductListByCategory: false,
        searchquery: query || "",
      },
      () => {
        if ((this.state.searchquery || "").length > 2) {
          clearTimeout(this.timer);
          this.ShowLoadSpinner();
          this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
        } else if (!query) {
          this.setState({ searchData: [] });
        }
      }
    );
  };

  triggerChange = () => this.ShowSearchResults("");

  ShowSearchResults = () => {
    const fuse = new Fuse(this.context.prodsAll || [], {
      keys: ["name", "sku", "subCategoryName"],
      threshold: 0.6,
      ignoreLocation: true,
      findAllMatches: true,
      distance: 120,
    });

    const result = fuse.search(this.state.searchquery || "");
    if (result.length) {
      // if single exact SKU match, auto add
      const only = result.length === 1 ? result[0].item : null;
      if (only && only.sku === this.state.searchquery) {
        this.context.addToPOSCart(this.context.selectedPOS, {
          prod: only,
          qty: 1,
        });
        Swal.fire({
          title: "Added Successfully",
          timer: 500,
          showConfirmButton: false,
        }).then(() => this.setState({ searchquery: "" }));
        this.HideLoadSpinner();
        return;
      }

      const finalResult = result.map((r) => r.item).slice(0, 15);
      this.setState({ searchData: finalResult }, this.HideLoadSpinner);
    } else {
      this.setState({ searchData: [] }, this.HideLoadSpinner);
    }
  };

  hasSearchResults = () => (this.state.searchData || []).length > 0;

  onClear = () => {
    this.setState({
      searchquery: "",
      searchData: [],
      showProductListByCategory: false,
    });
  };

  SubCategoryClicked = () => {
    this.setState({
      searchquery: "",
      searchData: [],
      showProductListByCategory: true,
    });
  };

  handleKeydownGlobal = (e) => {
    switch (true) {
      // CTRL + F1 -> SKU
      case e.ctrlKey && e.code === "F1":
        this.scanSkuRef?.current?.focus();
        this.scanSkuRef?.current?.select?.();
        break;

      // CTRL + F2 -> product select
      case e.ctrlKey && e.code === "F2":
        this.prodSelectRef?.focus?.();
        break;

      // F2 -> search
      case e.code === "F2":
        this.searchRef?.current?.focus();
        this.searchRef?.current?.select?.();
        break;

      // CTRL + F3 -> toggle favorites
      case e.ctrlKey && e.code === "F3":
        this.context.SetHideFav(!this.context.hideFav);
        break;

      default:
        break;
    }
  };

  componentDidMount() {
    this.LoadProducts();

    if (!this.context.isOfflineMode) this.getIPAddress();

    // focus search box initially
    setTimeout(() => {
      this.searchRef?.current?.focus();
    }, 0);

    document.addEventListener("keydown", this.handleKeydownGlobal);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    document.removeEventListener("keydown", this.handleKeydownGlobal);
    this.onClear();
  }

  render() {
    const colourStyles = {
      menuPortal: (base) => ({
        ...base,
        fontSize: "12px",
      }),
      option: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: isFocused ? "green" : null,
        color: isFocused ? "white" : "#333333",
      }),
    };

    if (this.context.reloadSearch == true) {
      this.onClear();
      this.context.ReSetReloadSearch();
    }
    if (this.context.clearSearchPos == true) {
      this.onClear();
      this.context.ClearSearchPos(false);
      return <></>;
    }

    return (
      <>
        {this.state.showWeightVariantProductModal === true ? (
          <WeightVariantProducModal
            prod={this.state.selectedWeightVariantProduct}
            onHide={this.HideWeightVariantProducModal}
            myClientIpAddress={this.state.myClientIpAddress}
          />
        ) : null}

        {window.innerWidth >= 900 ? (
          <>
            <div
              className="m-1 p-1 bg-white CornersRoundedSmall"
              style={{ fontSize: "12px" }}
            >
              <Table className="m-0 p-2 ">
                <tbody>
                  <tr>
                    <td
                      width="5%"
                      className=" m-0 p-0 border-0 bg-light "
                      style={{
                        verticalAlign: "top",
                        alignItems: "center",
                        backgroundColor: "white",
                        minHeight: window.innerHeight - 50 + "px",
                        maxHeight: window.innerHeight - 50 + "px",
                      }}
                    >
                      <div className="text-center text-black w-100">
                        <h5>
                          <b>CATEGORY</b>
                        </h5>
                        {this.context.hideFav === true ? (
                          <div>
                            <Button
                              variant="white"
                              className=" bg-light border text-center"
                              style={{ fontSize: "14px" }}
                              onClick={() =>
                                this.context.SetHideFav(!this.context.hideFav)
                              }
                            >
                              {this.context.hideFav === true ? (
                                <>
                                  <FaRegStar size={16} /> &nbsp;
                                  <b>Favorites </b>
                                  <small>(Ctrl+F3)</small>
                                </>
                              ) : (
                                <>&#8592;Home</>
                              )}
                              &nbsp;&nbsp;
                            </Button>
                          </div>
                        ) : null}
                      </div>

                      <MainCategoryStrip
                        SubCategoryClicked={this.SubCategoryClicked}
                      />
                    </td>

                    <td
                      width="95% "
                      className="mx-0 px-2 border-0"
                      style={{ verticalAlign: "top", alignItems: "center" }}
                    >
                      <div
                        className="w-100 p-0 m-0 "
                        style={{
                          minHeight: window.innerHeight - 50 + "px",
                          maxHeight: window.innerHeight - 50 + "px",
                        }}
                      >
                        {this.context.showNumberKeys === true ? (
                          <>
                            <Table className="p-5 ">
                              <tbody>
                                <tr>
                                  {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                                    <td key={n}>
                                      <Button
                                        className="w-100"
                                        style={{
                                          backgroundColor: "#00FFFF",
                                          color: "black",
                                          height: "50px",
                                          fontSize: "26px",
                                        }}
                                        onClick={() =>
                                          this.setState({
                                            searchsku:
                                              (this.state.searchsku || "") +
                                              String(n),
                                          })
                                        }
                                      >
                                        {n}
                                      </Button>
                                    </td>
                                  ))}
                                </tr>
                                <tr>
                                  <td>
                                    <Button
                                      className="w-100"
                                      style={{
                                        backgroundColor: "#00FFFF",
                                        color: "black",
                                        height: "50px",
                                        fontSize: "26px",
                                      }}
                                      onClick={() =>
                                        this.setState({
                                          searchsku:
                                            (this.state.searchsku || "") + "9",
                                        })
                                      }
                                    >
                                      9
                                    </Button>
                                  </td>
                                  <td>
                                    <Button
                                      className="w-100"
                                      style={{
                                        backgroundColor: "#00FFFF",
                                        color: "black",
                                        height: "50px",
                                        fontSize: "26px",
                                      }}
                                      onClick={() =>
                                        this.setState({
                                          searchsku:
                                            (this.state.searchsku || "") + "0",
                                        })
                                      }
                                    >
                                      0
                                    </Button>
                                  </td>
                                  <td colSpan={2}>
                                    <Button
                                      className="w-100"
                                      style={{
                                        backgroundColor: "#00FFFF",
                                        color: "black",
                                        height: "50px",
                                        fontSize: "26px",
                                      }}
                                      onClick={() =>
                                        this.setState({
                                          searchsku: (
                                            this.state.searchsku || ""
                                          ).slice(0, -1),
                                        })
                                      }
                                    >
                                      <i className="material-icons">&#xe14a;</i>
                                    </Button>
                                  </td>
                                  <td colSpan={2}>
                                    <Button
                                      className="w-100"
                                      style={{
                                        backgroundColor: "#00FFFF",
                                        color: "black",
                                        height: "50px",
                                        fontSize: "26px",
                                      }}
                                      onClick={() =>
                                        this.setState({ searchsku: "" })
                                      }
                                    >
                                      Clear
                                    </Button>
                                  </td>
                                  <td colSpan={2}>
                                    <Button
                                      className="w-100"
                                      style={{
                                        backgroundColor: "#00FFFF",
                                        color: "black",
                                        height: "50px",
                                        fontSize: "26px",
                                      }}
                                      onClick={() =>
                                        this.ShowSearchResultsSku("")
                                      }
                                    >
                                      Enter
                                    </Button>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </>
                        ) : null}

                        <table className="w-100 my-1 border-0">
                          <tbody>
                            <tr>
                              <td width="20%">
                                <FormControl
                                  id="scanSku"
                                  // inputMode="numeric"
                                  // type="number"
                                  type="text"
                                  style={{ fontSize: "14px" }}
                                  placeholder="SKU (Ctrl+F1)"
                                  className="text-dark"
                                  width="100%"
                                  aria-label="Search"
                                  value={this.state.searchsku}
                                  ref={this.scanSkuRef}
                                  onChange={(e) => {
                                    console.log("onchange");
                                    this.searchBySku(e.target.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.keyCode === 39) {
                                      if (this.prodSelectRef?.focus) {
                                        this.prodSelectRef.focus();
                                      }
                                    }
                                    if (e.keyCode === 13) {
                                      console.log("13");
                                      e.stopPropagation();
                                      this.ShowSearchResultsSku("");
                                    }
                                  }}
                                />
                              </td>
                              <td width="30%" style={{ fontSize: "14px" }}>
                                <Select
                                  id="prodSelect"
                                  menuPosition="fixed"
                                  maxMenuHeight={400}
                                  components={
                                    this.state.prodsSelect.length > 1000
                                      ? { MenuList }
                                      : undefined
                                  }
                                  styles={colourStyles}
                                  ref={(ref) => {
                                    // react-select passes a component ref; store it safely (not in state)
                                    this.prodSelectRef = ref;
                                  }}
                                  value={{
                                    value: "",
                                    label: "Select (Ctrl+F2)",
                                  }}
                                  onChange={(e) =>
                                    this.OnProductSelectChange(e)
                                  }
                                  options={this.state.prodsSelect}
                                  onKeyDown={(e) => {
                                    if (
                                      e.keyCode === 37 &&
                                      e.target.selectionStart === 0
                                    ) {
                                      if (this.scanSkuRef.current) {
                                        this.scanSkuRef.current.focus();
                                        this.scanSkuRef.current.select?.();
                                      }
                                    }
                                    // block numbers to avoid accidental typing into Select
                                    if (
                                      (e.keyCode >= 48 && e.keyCode <= 57) ||
                                      (e.keyCode >= 96 && e.keyCode <= 105)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </td>
                              <td width="50%" className="px-1 bg-light">
                                <Stack
                                  direction="horizontal"
                                  className="w-100 border-0"
                                >
                                  <BarCodeReader
                                    sendBarCode={this.readBarCode}
                                  />
                                  <FormControl
                                    id="search"
                                    type="search"
                                    placeholder="Search (F2)"
                                    className="text-dark bg-white "
                                    width="100%"
                                    aria-label="Search"
                                    value={this.state.searchquery}
                                    ref={this.searchRef}
                                    onChange={(e) =>
                                      this.searchItem(e.target.value)
                                    }
                                    style={{ fontSize: "14px" }}
                                  />
                                  <Button
                                    className="rounded-circle border mx-1"
                                    variant="white"
                                    onClick={this.onClear}
                                  >
                                    X
                                  </Button>
                                  <Dictaphone1
                                    sendVoiceTxt={this.readTextFromMicroPhone}
                                  />
                                </Stack>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {this.state.loadSpinnerOpen ? (
                          <h4 className="text-center w-100 text-danger">
                            <b>Loading...pls wait</b>
                          </h4>
                        ) : null}
                        {this.state.addedToCartMsg === true ? (
                          <h4 className="text-center w-100 text-danger">
                            <b>Added</b>
                          </h4>
                        ) : null}

                        <Table className="p-5">
                          <tbody>
                            <tr>
                              <td width="100%">
                                <div
                                  className="m-0 p-2  fixedTableHightOrderQuque overflow-scroll"
                                  style={{
                                    overflow: "hidden",
                                    maxHeight:
                                      this.context.showNumberKeys === true
                                        ? window.innerHeight - 250 + "px"
                                        : window.innerHeight - 150 + "px",
                                  }}
                                >
                                  {this.state.showProductListByCategory ===
                                  true ? (
                                    <ProductsList
                                      productView={this.state.productView}
                                    />
                                  ) : null}

                                  {this.hasSearchResults() ? (
                                    <div className="row justify-content-around py-2 mx-1">
                                      {this.state.searchData.map((prod) => (
                                        <div
                                          key={prod.id || prod.sku}
                                          className="card mb-3 mx-1 p-0 "
                                          style={{
                                            width:
                                              this.state.productView === "grid"
                                                ? "3.5cm"
                                                : "100%",
                                          }}
                                        >
                                          <div className="m-0 p-0 ">
                                            <ProductCard
                                              prod={prod}
                                              productView={
                                                this.state.productView
                                              }
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : null}

                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <br />
              <br />
              <br />
            </div>
          </>
        ) : (
          <>
            <div>
              {this.state.onscan === true ? (
                <BarCodeScannerModal
                  barcode={this.GetBarCode}
                  Close={this.OnScannerClose}
                />
              ) : null}

              <Table className="w-100 m-0 p-0 " size="sm">
                <tbody>
                  <tr className="w-100 m-0 p-0 ">
                    <td width="10%">
                      <ShopByCategoryPOS
                        SubCategoryClicked={this.SubCategoryClicked}
                      />
                    </td>
                    <td width="25%">
                      <FormControl
                        type="text"
                        id="scanSku"
                        size="lg"
                        placeholder="SKU"
                        className="text-dark fw-bold"
                        autoComplete="off"
                        role="presentation"
                        value={this.state.searchsku}
                        onChange={(e) => this.searchBySku(e.target.value)}
                      />
                    </td>
                    <td width="15%" className=" text-center">
                      <div className="px-3">
                        <Form.Check
                          className="text-center"
                          type="checkbox"
                          checked={this.context.showNumberKeys}
                          name="showNumberKeys"
                          label={"N"}
                          onChange={() => {
                            this.context.SetShowNumberKeys(
                              !this.context.showNumberKeys
                            );
                            localStorage.setItem(
                              "showNumberKeys",
                              !this.context.showNumberKeys
                            );
                          }}
                          style={{ width: "30px" }}
                        />
                      </div>
                    </td>
                    <td width="50%">
                      <Stack direction="horizontal" gap={3}>
                        <FormControl
                          id="search"
                          type="search"
                          size="lg"
                          placeholder="Search"
                          className=" text-dark text-black fw-bold"
                          aria-label="Search"
                          value={this.state.searchquery}
                          autoComplete="off"
                          role="presentation"
                          onChange={(e) => this.searchItem(e.target.value)}
                        />
                        <b>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                            onClick={this.OnScanner}
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                          </svg>
                        </b>
                      </Stack>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan={4}>
                      {this.context.showNumberKeys === true ? (
                        <Table className="p-5 ">
                          <tbody>
                            <tr>
                              {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                                <td key={n}>
                                  <Button
                                    className="w-100"
                                    style={{
                                      backgroundColor: "#00FFFF",
                                      color: "black",
                                      height: "50px",
                                      fontSize: "26px",
                                    }}
                                    onClick={() =>
                                      this.setState({
                                        searchsku:
                                          (this.state.searchsku || "") +
                                          String(n),
                                      })
                                    }
                                  >
                                    {n}
                                  </Button>
                                </td>
                              ))}
                            </tr>
                            <tr>
                              <td>
                                <Button
                                  className="w-100"
                                  style={{
                                    backgroundColor: "#00FFFF",
                                    color: "black",
                                    height: "50px",
                                    fontSize: "26px",
                                  }}
                                  onClick={() =>
                                    this.setState({
                                      searchsku:
                                        (this.state.searchsku || "") + "9",
                                    })
                                  }
                                >
                                  9
                                </Button>
                              </td>
                              <td>
                                <Button
                                  className="w-100"
                                  style={{
                                    backgroundColor: "#00FFFF",
                                    color: "black",
                                    height: "50px",
                                    fontSize: "26px",
                                  }}
                                  onClick={() =>
                                    this.setState({
                                      searchsku:
                                        (this.state.searchsku || "") + "0",
                                    })
                                  }
                                >
                                  0
                                </Button>
                              </td>
                              <td colSpan={2}>
                                <Button
                                  className="w-100"
                                  style={{
                                    backgroundColor: "#00FFFF",
                                    color: "black",
                                    height: "50px",
                                    fontSize: "26px",
                                  }}
                                  onClick={() =>
                                    this.setState({
                                      searchsku: (
                                        this.state.searchsku || ""
                                      ).slice(0, -1),
                                    })
                                  }
                                >
                                  <i className="material-icons">&#xe14a;</i>
                                </Button>
                              </td>
                              <td colSpan={2}>
                                <Button
                                  className="w-100"
                                  style={{
                                    backgroundColor: "#00FFFF",
                                    color: "black",
                                    height: "50px",
                                    fontSize: "26px",
                                  }}
                                  onClick={() =>
                                    this.setState({ searchsku: "" })
                                  }
                                >
                                  Clear
                                </Button>
                              </td>
                              <td colSpan={2}>
                                <Button
                                  className="w-100"
                                  style={{
                                    backgroundColor: "#00FFFF",
                                    color: "black",
                                    height: "50px",
                                    fontSize: "26px",
                                  }}
                                  onClick={() => this.ShowSearchResultsSku("")}
                                >
                                  Enter
                                </Button>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      ) : null}
                    </td>
                  </tr>
                </tbody>
              </Table>

              {this.state.loadSpinnerOpen ? (
                <h4 className="text-center w-100 text-danger">
                  <b>Loading...pls wait</b>
                </h4>
              ) : null}

              {this.state.showProductListByCategory === true ? (
                <div
                  className="fixedTableHightOrderQuque"
                  style={{ maxHeight: window.innerHeight - 300 + "px" }}
                >
                  <table className="w-100 m-0 p-0 ">
                    <tbody>
                      <tr className="w-100">
                        <td className="text-center"></td>
                        <td className="text-end ">
                          <Button variant="danger" onClick={this.onClear}>
                            Clear
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <ProductsList />
                </div>
              ) : null}

              {this.hasSearchResults() ? (
                <table className="w-100 m-0 p-0 ">
                  <tbody>
                    <tr className="w-100">
                      <td className="text-center">
                        <h4 className="text-danger text-center">
                          <b>Search results of "{this.state.searchquery}"</b>
                        </h4>
                      </td>
                      <td className="text-end ">
                        <Button variant="danger" onClick={this.onClear}>
                          Clear
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : null}

              <div
                className="col-md-12 fixedTableHightOrderQuque m-0 p-0"
                style={{ maxHeight: window.innerHeight - 300 + "px" }}
              >
                <Table
                  className="border m-0 p-0"
                  style={{ tableLayout: "fixed" }}
                >
                  <tbody>
                    {this.state.searchData.map((prod) => (
                      <tr key={prod.id || prod.sku}>
                        <td>
                          <div
                            className="card m-0 p-0 "
                            style={{ width: "100%" }}
                          >
                            <ProductCard prod={prod} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

// ---------------- WeightVariantProducModal ----------------

export class WeightVariantProducModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      productName: "",
      price: "",
      discount: "",
      qty: "0",
      sellingPriceUnit: 0,
      sellingPriceTotal: 0,
      firstload: false,
      intervalId: null,
    };
    this.keyupHandler = this.keyupHandler.bind(this);
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name.trim()]: value }, () => {
      if (["qty", "price", "discount"].includes(name)) {
        this.recomputeSellingPrice();
      }
    });
  };

  getWeight = () => {
    if (!this.props.myClientIpAddress) return;
    axios
      .get(
        process.env.REACT_APP_API +
          "Consumers/GetWeightByIPAddress/" +
          this.props.myClientIpAddress
      )
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.scaleValue != null
        ) {
          const qtyVal = Number(response.data.scaleValue).toFixed(3);
          this.setState({ qty: qtyVal }, () => this.recomputeSellingPrice());
        }
      })
      .catch(() => {});
  };

  setWeightToZero = () => {
    if (!this.props.myClientIpAddress) return;
    axios
      .post(
        process.env.REACT_APP_API +
          "Consumers/SetWeightOfIPAddressToZero/" +
          this.props.myClientIpAddress
      )
      .then(() => {})
      .catch(() => {});
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const result = (this.context.prodsAll || []).filter(
      (m) => m.name === this.state.productName
    );
    if (result.length > 0) {
      result[0].discount = this.state.discount;
      const qtyNum = parseFloat(this.state.qty || "0") || 0;
      this.context.addToPOSCart(this.context.selectedPOS, {
        prod: result[0],
        qty: qtyNum,
      });
    }
    this.setWeightToZero();
    if (this.state.intervalId) clearInterval(this.state.intervalId);
    this.props.onHide();
  };

  RefreshWeigh = () => {
    const id = setInterval(this.getWeight, 1000);
    this.setState({ intervalId: id });
  };

  keyupHandler(e) {
    if (e.keyCode === 27) {
      this.CloseModal();
    }
  }

  componentDidMount() {
    if (!this.state.firstload) {
      this.setState(
        {
          firstload: true,
          productName: this.props.prod?.name || "",
          price:
            this.props.prod?.mrp ||
            this.props.prod?.Mrp ||
            this.props.prod?.price ||
            "",
          discount:
            this.props.prod?.discount || this.props.prod?.Discount || "",
          qty: 1,
        },
        () => {
          const ctrl = document.getElementById("qty");
          if (ctrl) {
            ctrl.focus();
            ctrl.select?.();
          }
          this.recomputeSellingPrice();
        }
      );
      // if (!this.context.isOfflineMode) this.RefreshWeigh();
    }
    document.addEventListener("keyup", this.keyupHandler);
  }

  componentWillUnmount() {
    if (this.state.intervalId) clearInterval(this.state.intervalId);
    document.removeEventListener("keyup", this.keyupHandler);
  }

  CloseModal = () => {
    if (this.state.intervalId) clearInterval(this.state.intervalId);
    this.props.onHide();
  };

  // compute discount based on rules and update selling prices
  recomputeSellingPrice = () => {
    const prod = this.props.prod || {};
    const qty = parseFloat(this.state.qty || "0") || 0;

    const discountResult = this.calculateRuleDiscount(prod, qty);
    const mrp = parseFloat(prod?.mrp || prod?.Mrp || prod?.price || "0") || 0;
    const unitPrice = mrp - (mrp * discountResult.discountPercent) / 100.0;

    this.setState({
      discount: discountResult.discountPercent,
      sellingPriceUnit: Math.round(unitPrice * 100) / 100,
      sellingPriceTotal: Math.round(unitPrice * qty * 100) / 100,
    });
  };

  // calculates discount from product's selling price rule if applicable
  calculateRuleDiscount = (prod, qty) => {
    const qtyNum = parseFloat(qty || "0") || 0;
    const mrp = parseFloat(prod?.mrp || prod?.Mrp || prod?.price || "0") || 0;

    const rules = Array.isArray(this.context.sellingPriceRules)
      ? this.context.sellingPriceRules
      : [];

    const prodRuleId =
      prod?.sellingPriceBusinessRuleId || prod?.SellingPriceBusinessRuleId;
    if (!prodRuleId)
      return { discountPercent: parseFloat(prod?.discount || 0) || 0 };

    const matchingRule = rules.find(
      (r) =>
        String(r?.sellingPriceBusinessRuleId).toLowerCase() ===
        String(prodRuleId).toLowerCase()
    );
    if (!matchingRule)
      return { discountPercent: parseFloat(prod?.discount || 0) || 0 };

    const tiers = matchingRule?.sellingPriceRuleTiers || [];
    tiers.sort((a, b) => (a?.seqNo ?? 0) - (b?.seqNo ?? 0));

    const tier = tiers.find((t) => {
      const min = t?.minQtyInclusive ?? 0;
      const max = t?.maxQtyInclusive ?? Infinity;
      return qtyNum >= min && qtyNum <= max;
    });

    if (!tier) return { discountPercent: parseFloat(prod?.discount || 0) || 0 };

    if (tier.fixedSellingPrice != null) {
      const discountPercent = ((mrp - tier.fixedSellingPrice) / mrp) * 100;
      return { discountPercent: Math.round(discountPercent * 100) / 100 };
    } else if (tier.discountPercentOfMrp != null) {
      return { discountPercent: tier.discountPercentOfMrp };
    }

    return { discountPercent: parseFloat(prod?.discount || 0) || 0 };
  };

  render() {
    const qtyNum = parseFloat(this.state.qty || "0") || 0;
    const priceNum = parseFloat(this.state.price || "0") || 0;

    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        show={true}
        onHide={this.CloseModal}
      >
        <Form>
          <Modal.Header className="bg-warning" closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Add Product
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="show-grid">
            <Row>
              <Col>
                <h2>Product Name:</h2>
                <Form.Control
                  type="text"
                  size="lg"
                  name="productName"
                  id="productName"
                  value={this.state.productName}
                  required
                  disabled
                  autoComplete="new-password"
                  onChange={this.handleInputChange}
                  style={{ fontSize: "26px" }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <h2>Price (MRP):</h2>
              </Col>
              <Col>
                <Form.Control
                  type="number"
                  size="lg"
                  name="price"
                  value={this.state.price}
                  required
                  disabled
                  autoComplete="new-password"
                  onChange={this.handleInputChange}
                  style={{ fontSize: "26px" }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <h2>Discount(%):</h2>
              </Col>
              <Col>
                <Form.Control
                  type="number"
                  size="lg"
                  name="discount"
                  disabled
                  value={this.state.discount}
                  required
                  autoComplete="new-password"
                  onChange={this.handleInputChange}
                  style={{ fontSize: "26px" }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <h2>Quantity:</h2>
              </Col>
              <Col>
                <Stack direction="horizontal">
                  <Form.Control
                    type="number"
                    size="lg"
                    name="qty"
                    id="qty"
                    value={this.state.qty}
                    required
                    autoComplete="new-password"
                    onChange={this.handleInputChange}
                    style={{ fontSize: "26px" }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        this.handleSubmit(e);
                      }
                    }}
                  />
                </Stack>
              </Col>
            </Row>

            <Row>
              <Col>
                <h2>Selling Price (Total):</h2>
              </Col>
              <Col>
                <h2>
                  {isNaN(this.state.sellingPriceTotal)
                    ? 0
                    : this.state.sellingPriceTotal}
                </h2>
                <small>
                  Per unit:{" "}
                  {this.state.sellingPriceUnit ??
                    Math.round(priceNum * 100) / 100}
                </small>
              </Col>
            </Row>

            {this.context.sellingPriceRules ? (
              <Row className="mt-2">
                <Col>
                  <small className="text-muted">
                    Discount is dynamically applied using product-associated
                    selling price rule (if any).
                  </small>
                </Col>
              </Row>
            ) : null}
          </Modal.Body>

          <Modal.Footer className="bg-light">
            <Form.Group>
              <Button
                variant="primary"
                size="lg"
                disabled={qtyNum === 0}
                onClick={this.handleSubmit}
              >
                Add
              </Button>
            </Form.Group>
            <Button variant="danger" size="lg" onClick={this.CloseModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

// ---------------- Dictaphone helpers ----------------

const Dictaphone = (props) => {
  const commands = [
    {
      command: "*",
      callback: (txt) => props.sendVoiceTxt(txt),
      matchInterim: true,
    },
    {
      command: "clear",
      callback: () => props.sendVoiceTxt(""),
      matchInterim: true,
    },
  ];
  const { finalTranscript, resetTranscript, listening } = useSpeechRecognition({
    commands,
  });

  useEffect(() => {
    if (finalTranscript !== "") {
      // optional: you can use finalTranscript here
    }
  }, [finalTranscript]);

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    console.log(
      "Your browser does not support speech recognition software! Try Chrome desktop, maybe?"
    );
    return null;
  }

  // IMPORTANT: don't override SpeechRecognition reference itself.
  return (
    <div>
      <p>Microphone: {listening ? "on" : "off"}</p>
      <button onClick={SpeechRecognition.startListening}>Start</button>
      <button onClick={SpeechRecognition.stopListening}>Stop</button>
    </div>
  );
};

class BarCodeReader extends Component {
  constructor(props) {
    super(props);
    this.state = { result: "barcode" };
  }
  handleScan = (data) => {
    if (!data) return;
    this.setState({ result: data });
    this.props.sendBarCode(data);
  };
  handleError = (err) => {
    // silent fail
    // console.error(err);
  };
  render() {
    return (
      <div className="m-0 p-0">
        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />
      </div>
    );
  }
}

const Dictaphone1 = (props) => {
  const commands = [
    {
      command: "*",
      callback: (txt) => props.sendVoiceTxt(txt),
      matchInterim: true,
    },
    {
      command: "clear",
      callback: () => props.sendVoiceTxt(""),
      matchInterim: true,
    },
  ];
  const { finalTranscript, listening } = useSpeechRecognition({ commands });

  useEffect(() => {
    if (finalTranscript !== "") {
      // no-op
    }
  }, [finalTranscript]);

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    console.log(
      "Your browser does not support speech recognition software! Try Chrome desktop, maybe?"
    );
    return null;
  }

  const listenContinuously = () => {
    SpeechRecognition.startListening({
      continuous: true,
      language: "en-GB",
    });
  };

  return listening ? (
    <Button variant="white" onClick={SpeechRecognition.stopListening}>
      <BsFillMicFill size={14} />
    </Button>
  ) : (
    <Button variant="white" onClick={listenContinuously}>
      <BsFillMicMuteFill size={14} />
    </Button>
  );
};

// ---------------- Category components ----------------

export class MainCategoryStrip extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: null,
    };
  }

  onMainCategoryClickEvent = (id) => {
    this.setState({ selectedCategory: id });
    this.context.UpdateReloadProductListView("true");
    this.context.GetProductsByMainCategoryId(id, null, null);
    this.props.SubCategoryClicked();
  };

  render() {
    return (
      <div
        className="p-2"
        style={{
          maxHeight: window.innerHeight - 100 + "px",
          overflowY: "auto",
          background: "#f8f9fa",
          borderRadius: "12px",
          boxShadow: "inset 0 0 4px rgba(0,0,0,0.05)",
        }}
      >
        {(this.context.mainCategories || [])
          .slice()
          .sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
          .map((maincategory) => {
            const isActive = this.state.selectedCategory === maincategory.id;
            return (
              <Button
                key={maincategory.id}
                onClick={() => this.onMainCategoryClickEvent(maincategory.id)}
                className="d-flex align-items-center my-2 w-100"
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  textAlign: "left",
                  borderRadius: "10px",
                  border: isActive ? "2px solid #0d6efd" : "1px solid #dee2e6",
                  background: isActive ? "#e7f1ff" : "white",
                  color: isActive ? "#0d6efd" : "#333",
                  boxShadow: isActive
                    ? "0 2px 6px rgba(13,110,253,0.3)"
                    : "0 1px 3px rgba(0,0,0,0.05)",
                  transition: "all 0.2s ease",
                  padding: "10px 12px",
                }}
              >
                {/* Circle with first letter if no icon */}
                <div
                  style={{
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    backgroundColor: isActive ? "#0d6efd" : "#e9ecef",
                    color: isActive ? "white" : "#495057",
                    fontSize: "13px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "10px",
                  }}
                >
                  {maincategory.name?.charAt(0).toUpperCase()}
                </div>

                {/* Category Name */}
                <span>{maincategory.name}</span>
              </Button>
            );
          })}
      </div>
    );
  }
}

export const ShopByCategoryPOS = (props) => {
  const {
    mainCategories = [],
    subCategories = [],
    GetProductsByMainCategoryId,
    GetProductsBySubCategoryId,
    UpdateReloadProductListView,
  } = useContext(CartContext);
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const { anchorProps, hoverProps } = useHover(isOpen, setOpen);

  const onMainCategoryClickEvent = (event) => {
    UpdateReloadProductListView("true");
    GetProductsByMainCategoryId(event.currentTarget.id, null, null);
    props.SubCategoryClicked();
  };

  const OnSubCategoryClickEvent = (event) => {
    UpdateReloadProductListView("true");
    GetProductsBySubCategoryId(
      event.syntheticEvent.currentTarget.id,
      null,
      null
    );
    props.SubCategoryClicked();
  };

  return (
    <>
      <div ref={ref} {...anchorProps} className="m-0 p-0">
        <Button
          className={"dropdown-toggle my-0 border-0"}
          style={{ backgroundColor: "white", color: "black" }}
        >
          <img
            src={"/images/menu1.png"}
            className=" mx-auto"
            alt="..."
            style={{ width: ".5cm" }}
          />
        </Button>
      </div>

      <ControlledMenu
        {...hoverProps}
        state={isOpen ? "open" : "closed"}
        anchorRef={ref}
        onClose={() => setOpen(false)}
      >
        {mainCategories
          .slice()
          .sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
          .map((maincategory) => (
            <div
              key={maincategory.id}
              id={maincategory.id}
              onClick={onMainCategoryClickEvent}
            >
              <SubMenu
                label={maincategory.name}
                className="my-2 fw-bold"
                type="action"
              >
                {subCategories
                  .filter(
                    (subcategory) =>
                      subcategory.mainCategoryId === maincategory.id
                  )
                  .map((subcategory) => (
                    <MenuItem
                      key={subcategory.id}
                      id={subcategory.id}
                      onClick={OnSubCategoryClickEvent}
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      {subcategory.name}
                    </MenuItem>
                  ))}
              </SubMenu>
            </div>
          ))}
      </ControlledMenu>
    </>
  );
};

// ---------------- Barcode Scanner Modal ----------------

class BarCodeScannerModal extends Component {
  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={true}
          backdrop="static"
          keyboard={false}
          dialogClassName="BrandModal"
          onHide={this.props.Close}
        >
          <Modal.Header closeButton className="bg-warning">
            <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid ">
            <BarcodeScanner barcode={this.props.barcode} />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export const BarcodeScanner = (props) => {
  const [result, setResult] = useState("");
  const { ref } = useZxing({
    onDecodeResult(result) {
      const text = result.getText();
      setResult(text);
      props.barcode(text);
    },
  });

  return (
    <>
      <video ref={ref} />
      <p>
        <span>Last result:</span>
        <span>{result}</span>
      </p>
    </>
  );
};

// ---------------- react-select virtualized MenuList ----------------

export class MenuList extends Component {
  render() {
    const { options = [], children = [], maxHeight, getValue } = this.props;
    const [value] = getValue();
    const idx = options.indexOf(value);
    const initialOffset = (idx >= 0 ? idx : 0) * 35;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={35}
        initialScrollOffset={initialOffset}
        style={{ lightingColor: "black" }}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  }
}
